<template>
  <!-- 提款成功 -->
  <div>
    <CustomHead srcName="success.png">
      <h3>放款成功</h3>
      <p class="warn">请注意查收短信通知!</p>
    </CustomHead>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">借款人</span>
        <span class="infoListRight">{{succInfo.custName}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">提现银行</span>
        <span class="infoListRight">{{succInfo.putoutCardBank}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">银行卡</span>
        <span class="infoListRight">{{succInfo.putoutCardNo}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款金额</span>
        <span class="infoListRight">¥{{succInfo.drawAmt}}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款期限</span>
        <span class="infoListRight">{{succInfo.term}}个月</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">贷款利率</span>
        <span class="infoListRight">{{succInfo.execRate}}%</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">还款方式</span>
        <span class="infoListRight">{{succInfo.rtnTypes}}</span>
      </li>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="goToNextPage"
    />
  </div>
</template>
<script>
import CustomHead from '@/components/CustomHead.vue';
import Button from '@/components/Button.vue';

export default {
  name: 'signContract',
  data() {
    return {
      danger: 'danger',
      draw: '查看我的融资',
      succInfo: {}, // 提款成功反显信息
    };
  },
  components: {
    Button,
    CustomHead,
  },
  mounted() {
    this.getWithdrawalInfo();
  },
  methods: {
    async getWithdrawalInfo() {
      const { data } = await this.$api.OtherPage.queryEchoInfo({
        orderId: this.$route.query.orderId,
        pageId: this.$route.query.pageId,
      });
      this.succInfo = data;
    },
    goToNextPage() {
      this.$router.push('/supermarket/v2/myload');
    },
  },
};
</script>
<style scoped>
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: #1c2438;
  font-size: 14px;
}
.warn {
  color: #9ea7b4;
  font-size: 17px;
  font-size: 700;
  text-align: center;
}
.infoListRight {
  color: #000;
  font-size: 14px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.headerStatus {
  padding-top: 35px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
</style>
